import { render } from "./SideBarNavProposalPBoms.vue?vue&type=template&id=6367503e&scoped=true&ts=true"
import script from "./SideBarNavProposalPBoms.vue?vue&type=script&lang=ts"
export * from "./SideBarNavProposalPBoms.vue?vue&type=script&lang=ts"

import "./SideBarNavProposalPBoms.vue?vue&type=style&index=0&id=6367503e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6367503e"]])

export default __exports__